<template>
    <b-th v-bind="$props">
        <slot />
    </b-th>
</template>

<script>
import { BTh } from 'bootstrap-vue'

export default {
    components: { BTh },
    props: {
        colspan: { type: [Number, String], default: null },
        rowspan: { type: [Number, String], default: null },
        stackedHeading: { type: String },
        stickyColumn: { type: Boolean, default: false },
    }
}
</script>